import {
  faShoppingCart,
  faMoneyBillWave,
  faGift,
  faDiceSix
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Method from "../components/shop/method";

//import Paypal from "../components/shop/cashout/paypal";
import Litecoin from "../components/shop/cashout/litecoin";
import Solana from "../components/shop/cashout/solana";
import BTCCash from "../components/shop/cashout/btccash";
import CSDeals from "../components/shop/cashout/csdeals";
import Bitcoin from "../components/shop/cashout/bitcoin";

import Steam from "../components/shop/cashout/steam"
import GeneralGiftcard from "../components/shop/cashout/general-giftcards";
import Discord from "../components/shop/cashout/discord";

import { useState } from "react";

import Rp from "../components/all/rp"
// import WhaleIo from "../components/shop/cashout/whale";
import AgeConfirmation from "../components/shop/age-confirmation";
import GambleConsent from "../components/shop/consent";
import { createNotification } from "../components/api";
import Casesgg from "../components/shop/cashout/cases";
import Clash from "../components/shop/cashout/clash";
import RustClash from "../components/shop/cashout/rustclash";

const Shop = ({ user, settings, ws }) => {
  const [option, setOption] = useState(0);
  const [consent, setConsent] = useState(false);
  const [showConsent, setShowConsent] = useState(false);
  const [ageConfirmation, setAgeConfirmation] = useState(false);

  const click = (num) => {
    setOption(option === num ? 0 : num);
    setTimeout(() => {
      ["crypto", "giftcards", "partners"].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    }, 500);
  };

  const partnerOption = (option) => {
    if (!user) {
      return createNotification('error', 'You must be logged in to access this reward.');
    }

    if (user?.banned || user?.frozen) return null;

    if (!user?.confirmedAge) {
      return setAgeConfirmation(true);
    }

    if (!consent) {
      return setShowConsent(true);
    }

    return click(option);
  }

  return (
    <>
      {ageConfirmation && <AgeConfirmation setShow={setAgeConfirmation} user={user} />}
      {showConsent && <GambleConsent setShow={setShowConsent} user={user} setConsent={setConsent} />}
      <Rp user={user} />
      <div className="shop-container">
        <div className="title">
          <span className="blue">
            <FontAwesomeIcon icon={faShoppingCart} />
          </span>
          <p>Shop</p>
        </div>

        <div className="methods">
          <div className="section-title">
            <p>
              <span className="blue">
                <FontAwesomeIcon icon={faMoneyBillWave} />
              </span>{" "}
              Cash &amp; Crypto
            </p>
          </div>

          <Method
            disabled={!settings?.paypal}
            img="/companies/paypal.svg"
            bg="linear-gradient(308.21deg, #263B80 -73.3%, #25BCFF 133.19%)"
            active={option === 1}
            click={() => (user?.banned || user?.frozenn ? null : click(1))}
          />

          <Method
            disabled={!settings?.ltc}
            img="/companies/ltc.svg"
            bg="linear-gradient(180deg, #A1A4C9 -3.68%, rgba(126, 128, 154, 0.7) 100%)"
            active={option === 2}
            click={() => (user?.banned || user?.frozen ? null : click(2))}
          />
          <Method
            disabled={!settings?.btc}
            img="/companies/btc.svg"
            bg="linear-gradient(180deg,rgb(192, 152, 171) -3.68%, rgba(176, 177, 194, 0.7) 100%)"
            active={option === 11}
            click={() => (user?.banned || user?.frozen ? null : click(11))}
          />
          <Method
            disabled={!settings?.sol}
            img="/companies/sol.svg"
            bg="linear-gradient(360deg, #DA20FE 0%, #08F5A7 100%)"
            active={option === 3}
            click={() => (user?.banned || user?.frozen ? null : click(3))}
          />
          <Method
            disabled={!settings?.bch}
            img="/companies/btccash.svg"
            bg="linear-gradient(180deg, #0AC18E -3.68%, #177D3E 100%)"
            active={option === 4}
            click={() => (user?.banned || user?.frozen ? null : click(4))}
          />
          <Method
            disabled={!settings?.visa}
            img="/companies/visa.svg"
            bg="white"
            active={option === 5}
            click={() => (user?.banned || user?.frozen ? null : click(5))}
          />

          {/* <Method
            disabled={!settings?.whaleio}
            img="/companies/whaleio.png"
            banned={user?.whaleio_ban}
            bg="whaleio"
            active={option === 12}
            click={() => whaleIoOption()}
          /> */}
        </div>

        {[1, 2, 3, 4, 5, 11].includes(option) && (
          <div className="withdraw-options" id="crypto">
            {option === 1 ? (
              <GeneralGiftcard img="/companies/paypal.svg"
                bg="linear-gradient(308.21deg, #263B80 -73.3%, #25BCFF 133.19%)"
                fee={500}
                amounts={[5000, 10000, 20000, 25000]}
                key="paypal"
                type="paypal" />
            ) : option === 2 ? (
              <Litecoin img="/companies/ltc.svg" />
            ) : option === 3 ? (
              <Solana img="/companies/sol.svg" />
            ) : option === 4 ? (
              <BTCCash img="/companies/btccash.svg" />
            ) : option === 5 ? (
              <GeneralGiftcard
                img="/companies/visa.svg"
                bg="white"
                fee={0.1}
                key="visa"
                type="visa"
              />
            ) : option === 11 ? (
              <Bitcoin img="/companies/btc.svg" />
            ) : null}
          </div>
        )}

        <div className="methods">
          <div className="section-title">
            <p>
              <span className="blue">
                <FontAwesomeIcon icon={faGift} />
              </span>{" "}
              Gift cards
            </p>
          </div>

          <Method
            disabled={!settings?.roblox}
            img="/companies/roblox.svg"
            bg="#EA352C"
            active={option === 6}
            click={() => (user?.banned || user?.frozen ? null : click(6))}
          />
          {/* <Method
            disabled={!settings?.csdeals}
            img="/companies/csdeals.svg"
            bg="#DE8E1F"
            active={option === 7}
            click={() => (user?.banned || user?.frozen ? null : click(7))}
          /> */}
          <Method
            disabled={!settings?.nitro}
            img="/companies/nitro.svg"
            bg="#868FE9"
            active={option === 8}
            click={() => (user?.banned || user?.frozen ? null : click(8))}
          />
          <Method
            disabled={!settings?.amazon}
            img="/companies/amazon.svg"
            bg="white"
            active={option === 9}
            click={() => (user?.banned || user?.frozen ? null : click(9))}
          />
          <Method
            disabled={!settings?.steam}
            img="/companies/steam.svg"
            bg="#393C74"
            active={option === 10}
            click={() => (user?.banned || user?.frozen ? null : click(10))}
          />
        </div>

        {[6, 7, 8, 9, 10].includes(option) && (
          <div className="withdraw-options" id="giftcards">
            {option === 6 ? (
              <GeneralGiftcard
                img="/companies/roblox.svg"
                bg="#EA352C"
                fee={0}
                key="roblox"
                amounts={[10000, 20000, 40000, 60000]}
                type="roblox"
              />
            ) : option === 7 ? (
              <CSDeals img="/companies/csdeals.svg" />
            ) : option === 8 ? (
              <Discord />
            ) : option === 9 ? (
              <GeneralGiftcard
                img="/companies/amazon.svg"
                bg="white"
                fee={0}
                key="amazon"
                type="amazon"
              />
            ) : option === 10 ? (
              <Steam
                img="/companies/steam.svg"
                bg="#393C74"
                fee={0}
                key="steam"
                type="steam"
              />
            ) : null}
          </div>
        )}

        {/* <div className="methods">
          <div className="section-title">
            <p>
              <span className="blue">
                <FontAwesomeIcon icon={faDiceSix} />
              </span>{" "}
              Partners
            </p>
          </div>

        </div> */}

      </div>

      <style jsx>{`
        .shop-container {
          width: 100%;
          height: 100%;

          padding: 50px 200px;

          overflow-x: hidden;
          overflow-y: auto;
        }

        .shop-container::-webkit-scrollbar {
          display: none;
        }

        .title {
          font-weight: 500;
          font-size: 24px;

          gap: 10px;
          display: flex;
          align-items: center;

          margin-bottom: 75px;
        }

        .title p {
          margin: unset;
        }

        .blue {
          color: #4daeff;
        }

        .section-title {
          position: absolute;
          background: #141a31;
          border-radius: 12px 12px 0px 0px;
          padding: 3px 10px;
          height: 30px;

          top: -30px;
          left: 0;
        }

        .section-title p {
          margin: unset;
        }

        .withdraw-options {
          margin-bottom: 105px;
        }

        .methods {
          background: #141a31;
          width: 100%;
          border-radius: 0px 12px 12px 12px;

          display: grid;
          grid-template-columns: repeat(4, minmax(180px, 1fr));
          grid-gap: 15px;
          padding: 15px;

          position: relative;

          margin-bottom: 75px;
        }

        @media only screen and (max-width: 1100px) {
          .shop-container {
            padding: 50px 100px;
          }
          .methods {
            grid-template-columns: repeat(3, minmax(180px, 1fr));
          }
        }

        @media only screen and (max-width: 870px) {
          .shop-container {
            padding: 50px;
          }
          .methods {
            grid-template-columns: repeat(3, minmax(180px, 1fr));
          }
        }

        @media only screen and (max-width: 870px) {
          .shop-container {
            padding: 25px;
          }
          .methods {
            grid-template-columns: repeat(1, minmax(180px, 1fr));
          }
        }

        @media only screen and (max-width: 400px) {
          .shop-container {
            padding: 50px 25px;
          }
        }

        @media only screen and (max-width: 290px) {
          .shop-container {
            padding: 50px 0px;
          }
          .methods {
            grid-template-columns: repeat(1, minmax(180px, 1fr));
          }
        }
      `}</style>
    </>
  );
};

export default Shop;
